<template>
  <div>
    <div v-if="menu === 0" class="how">
      <div v-html="editorContent"></div>
    </div>
    <div v-else class="div">
      <div class="top-navi">
        <div
          v-for="(item, index) in navItem"
          :key="'topNavi' + index"
          :class="['top-navi__item', {selected: item.selected}]"
          @click="onClickNavItem(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="action-selector">
        <div class="action-item" :class="{on: mailReceiver.action === 'C'}" @click="mailReceiver.action = 'C'">
          <div class="is-14m">신청</div>
          <circle-select-box :on="mailReceiver.action === 'C'" @click="mailReceiver.action = 'C'" />
        </div>
        <div class="action-item" :class="{on: mailReceiver.action === 'U'}" @click="mailReceiver.action = 'U'">
          <div class="is-14m">변경</div>
          <circle-select-box :on="mailReceiver.action === 'U'" @click="mailReceiver.action = 'U'" />
        </div>
        <div class="action-item" :class="{on: mailReceiver.action === 'D'}" @click="mailReceiver.action = 'D'">
          <div class="is-14m">거부</div>
          <circle-select-box :on="mailReceiver.action === 'D'" @click="mailReceiver.action = 'D'" />
        </div>
      </div>
      <div class="receive">
        <div class="receive-wrap">
          <div class="receive-title">수신자 정보</div>
          <div class="input-wrap">
            <EmailInputForm title="회사명" :type="'companyName'" @inputData="inputData" placeholder="회사명을 입력해주세요" />
            <EmailInputForm title="부서" :type="'department'" @inputData="inputData" placeholder="부서를 입력해주세요" />
            <EmailInputForm title="성명" :type="'name'" @inputData="inputData" placeholder="성명을 입력해주세요" />
            <EmailInputForm title="직위" :type="'position'" @inputData="inputData" placeholder="직위를 입력해주세요" />
            <EmailInputForm
              title="이메일"
              :type="'email'"
              @inputData="inputData"
              placeholder="이메일을 입력해 주세요"
              :style="{borderBottom: mailReceiver.action === 'D' ? '1px solid #dbdbdb' : 'none'}"
            />
            <div v-show="mailReceiver.action !== 'D'" class="input-box">
              <div class="is-14m">관심분야</div>
              <div class="interest-wrap">
                <div v-for="(item, index) in interestItem" :key="'interest' + index" class="interest-item" @click="toggleInterest(item)">
                  <div class="item">
                    <square-select-box :on="mailReceiver.interest.includes(item)" />
                    <div class="item-name">{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
            <EmailInputForm
              v-show="mailReceiver.action !== 'D'"
              title="기타사항"
              :type="'etc'"
              @inputData="inputData"
              placeholder="관심 분야 선택항목 이외 내용을 입력해 주세요"
              style="border-bottom: 1px solid #dbdbdb"
            />
          </div>
        </div>
        <div v-show="navItem[1].selected && mailReceiver.action !== 'D'" class="receive-wrap">
          <div class="receive-title">수신처 정보</div>
          <div class="input-wrap">
            <EmailInputForm title="휴대폰 번호" :type="'phoneNo'" @inputData="inputData" placeholder="휴대폰 번호를 입력해주세요" />
            <div class="input-box">
              <div class="is-14m">우편번호</div>
              <input
                v-model="mailReceiver.zipCode"
                type="text"
                class="is-14r"
                readonly
                placeholder="우편번호를 입력해주세요"
                @click="openFindAddress"
              />
            </div>
            <!-- 주소 검색  -->
            <div
              id="wrap"
              style="display: none; border: 1px solid; width: 736px; height: 470px; top: 720px; z-index: 9; margin: 5px 0; position: absolute"
            >
              <!-- 주소 검색 닫기 버튼 -->
              <img
                id="btnFoldWrap"
                src="//t1.daumcdn.net/postcode/resource/images/close.png"
                style="cursor: pointer; position: absolute; right: 0; top: -1px; z-index: 1"
                alt="접기 버튼"
                @click="onClosePost"
              />
            </div>
            <div class="input-box">
              <div class="is-14m">주소</div>
              <input
                v-model="mailReceiver.address"
                type="text"
                class="is-14r bg-gray-100"
                readonly
                placeholder="우편번호에 따라 주소 자동입력"
              />
            </div>
            <div class="input-box" style="border-bottom: 1px solid #dbdbdb">
              <div class="is-14m">세부주소</div>
              <input
                v-model="mailReceiver.addressDetail"
                type="text"
                name="detail_address"
                class="is-14r"
                placeholder="세부주소를 입력해주세요"
                @input="inputData('addressDetail', $event.target.value)"
              />
            </div>
          </div>
        </div>
        <div class="notice-wrap is-14r">
          한국인사관리협회 개인정보 수집 및 이용에 대한 안내<br /><br />

          한국인사관리협회 (www.insabank.com 이하 "회사" 또는 "한국인사관리협회"라 함)는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및
          정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한
          개인정보취급방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
        </div>
        <div class="sup-agree" @click="agree = !agree">
          <div>
            <svg v-if="!agree" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 18.5001C3.34315 18.5001 2 17.1569 2 15.5001V5.5C2 3.84315 3.34315 2.5 5 2.5H15C16.6569 2.5 18 3.84315 18 5.5L18 15.5001C18 17.1569 16.6569 18.5001 15 18.5001H5Z"
                fill="white"
                stroke="#DBDBDB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg v-else width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 18.5001C3.34315 18.5001 2 17.1569 2 15.5001V5.5C2 3.84315 3.34315 2.5 5 2.5H15C16.6569 2.5 18 3.84315 18 5.5L18 15.5001C18 17.1569 16.6569 18.5001 15 18.5001H5Z"
                fill="#0058AA"
              />
              <path
                d="M12.6667 8.83325L8.19205 12.8333L6.66675 11.4698"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="is-14m">위 사항을 모두 읽었으며 동의합니다.</div>
        </div>
        <div class="confirm-btn is-16m" :class="{'agree': agree}" @click="postSeminarMailApplication">확인</div>
      </div>
    </div>
    <Spinner v-if="isSpinner" />
  </div>
</template>

<script>
import {useSeminarStore} from '~/store/seminar/index.js'
import CircleSelectBox from 'assets/svg/circle-select-box.vue'
import SquareSelectBox from 'assets/svg/square-select-box.vue'
import {useCommonStore} from '~/store/common/index.js'
import Spinner from '~/components/common/loading/Spinner.vue'

export default {
  name: 'SeminarTab4',
  components: {Spinner, SquareSelectBox, CircleSelectBox},
  setup() {
    const store = useSeminarStore()
    const commonStore = useCommonStore()
    return {store, commonStore}
  },

  props: {
    menu: {
      type: Number,
      default: ''
    }
  },
  data() {
    return {
      isSpinner: false,
      agree: false,
      editorContent: '',
      navItem: [
        {
          name: '이메일 수신',
          selected: false
        },
        {
          name: '우편물 수신',
          selected: false
        }
      ],
      interestItem: ['인사', '교육', '노무/노사', '총무', '사보', '비서'],
      mailReceiver: {
        type: '02',
        action: 'C',
        companyName: '',
        department: '',
        name: '',
        position: '',
        email: '',
        receiverName: '',
        zipCode: '',
        address: '',
        addressDetail: '',
        interest: [],
        etc: ''
      },
      filePath: {
        pdf: '',
        excel: '',
        image: ''
      }
    }
  },
  async mounted() {
    await this.getEditorBoard()
    this.onClickNavItem(this.navItem[0])
    await this.getSeminarFileList()
  },
  methods: {
    // 카카오 주소찾기
    openFindAddress() {
      const elementWrap = document.getElementById('wrap')
      const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop)
      const self = this

      new daum.Postcode({
        oncomplete(data) {
          // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.
          let addr = '' // 주소 변수

          // 사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
          if (data.userSelectedType === 'R') {
            // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress
          } else {
            // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress
          }
          // 우편번호 저장
          self.mailReceiver.zipCode = data.zonecode
          // 주소 저장
          self.mailReceiver.address = addr
          elementWrap.style.display = 'none'
          // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
          document.body.scrollTop = currentScroll
        },
        onclose(state) {
          document.querySelector('input[name="detail_address"]').focus()
        },
        shorthand: false,
        width: '100%',
        height: '100%'
      }).embed(elementWrap)
      // iframe을 넣은 element를 보이게 한다.
      elementWrap.style.display = 'block'
    },
    // 카카오 주소 찾기 close
    onClosePost() {
      document.querySelector('#wrap').style.display = 'none'
    },
    async getEditorBoard() {
      try {
        this.isSpinner = true
        const payload = {
          parentType: 'seminar',
          type: '04'
        }
        const {data} = await this.commonStore.getEditorBoard(payload)
        this.editorContent = data.board.content
      } catch (error) {
        console.log(error)
      } finally {
        this.isSpinner = false
      }
    },
    async getSeminarFileList() {
      try {
        const {data} = await this.store.getSeminarFileList()
        const files = data.files
        this.filePath = {
          pdf: files.find(file => file.type === 'pdf')?.path,
          excel: files.find(file => file.type === 'excel')?.path,
          image: files.find(file => file.type === 'image')?.path
        }
      } catch (error) {
        console.log(error)
      }
    },
    toggleInterest(item) {
      if (this.mailReceiver.interest.includes(item)) {
        this.mailReceiver.interest = this.mailReceiver.interest.filter(interest => interest !== item)
      } else {
        this.mailReceiver.interest.push(item)
      }
    },
    // 이메일 데이터 입력
    inputData(type, value) {
      this.mailReceiver[type] = value
    },
    validateData() {
      const type = this.mailReceiver.type
      if (!this.mailReceiver.companyName) {
        alert('회사명을 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.department) {
        alert('부서를 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.name) {
        alert('성명을 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.position) {
        alert('직위를 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.email) {
        alert('이메일을 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.email.includes('@')) {
        alert('이메일 형식이 올바르지 않습니다.')
        return false
      }
      if (this.mailReceiver.interest.length === 0) {
        alert('관심분야를 선택해주세요.')
        return false
      }
      // 우편물 수신일경우
      if (type === '01') {
        if (!this.mailReceiver.receiverName) {
          alert('이름을 입력해주세요.')
          return false
        }
        if (!this.mailReceiver.zipCode) {
          alert('우편번호를 입력해주세요.')
          return false
        }
        if (!this.mailReceiver.address) {
          alert('주소를 입력해주세요.')
          return false
        }
        if (!this.mailReceiver.addressDetail) {
          alert('세부주소를 입력해주세요.')
          return false
        }
      }

      return true
    },
    async postSeminarMailApplication() {
      if (!this.validateData()) return
      try {
        this.isSpinner = true
        await this.store.postSeminarMailApplication(this.mailReceiver)
        alert('신청이 완료되었습니다.')
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSpinner = false
      }
    },
    onClickNavItem(item) {
      this.navItem.forEach(navItem => {
        navItem.selected = false
      })
      item.selected = true
    }
  }
}
</script>

<style scoped lang="scss">
.top-navi {
  border-top: 1px solid #dbdbdb;
  border-bottom: 1px solid #dbdbdb;
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .top-navi__item {
    padding: 18px 16px;
    color: #606060;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
    cursor: pointer;

    &:hover {
      color: #0058aa;
    }

    &.selected {
      font-weight: 700;
      color: #0058aa;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 3px;
        background: #0058aa;
      }
    }
  }
}

.action-selector {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;

  .action-item {
    padding: 8px;
    cursor: pointer;
    display: flex;
    gap: 8px;
    border-radius: 4px;
    border: 1px solid #dbdbdb;
    background: #fff;

    &.on {
      border: 1px solid #0058aa;
    }
  }
}

.receive {
  .receive-wrap {
    margin-bottom: 24px;

    .receive-title {
      color: #121212;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 170%; /* 23.8px */
      letter-spacing: -0.14px;
      margin-bottom: 12px;
    }

    .input-box {
      display: flex;
      border: 1px solid #dbdbdb;
      border-bottom: 0;

      .is-14m {
        width: 100px;
        padding: 14px;
        background: #fbfbfb;
        border-right: 1px solid #dbdbdb;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .is-14r {
        width: 634px;
        padding: 16px;

        &::placeholder {
          color: #909090;
          font-family: Pretendard;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }
      }

      .interest-wrap {
        display: flex;
        padding: 16px;
        gap: 16px;

        .interest-item {
          .item {
            display: flex;
            gap: 4px;
            cursor: pointer;
            align-items: center;

            .item-name {
              font-size: 14px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  .notice-wrap {
    padding: 16px;
    border: 1px solid #dbdbdb;
    margin-bottom: 24px;
  }

  .sup-agree {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    margin-bottom: 24px;
  }

  .confirm-btn {
    color: #909090;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 125%; /* 20px */
    display: inline-flex;
    padding: 14px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    border: 1px solid #dbdbdb;
    background: #dbdbdb;
    pointer-events: none;

    &.agree {
      cursor: pointer;
      pointer-events: auto;
      background: #0058aa;
      color: #fff;
    }
  }
}
</style>
